(() => {
  'use strict';
  const configNode = document.getElementById('outletlet-fr-de-cart-ui-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  const locale = String(config.locale || '');
  if (config.enabled !== true || config.deployment !== 'release' ||
      config.pageType !== 'cart' || !['fr', 'de'].includes(locale) ||
      !/\/cart\/?$/.test(window.location.pathname) ||
      document.documentElement.lang.toLowerCase().split('-')[0] !== locale) return;
  const namespace = 'OutletletFrDeCartUi';
  if (window[namespace]?.destroy) window[namespace].destroy();

  const scopes = ['.shopify-section-group-header-group', 'footer-group', '#MainContent', 'a.skip-link[href="#MainContent"]'];
  const protectedSelector = 'script,style,noscript,template,textarea,input,select,option,iframe,svg,picture,img,[contenteditable],.money,[data-money],[data-price],[data-product-title],.cart-item__name,.cart__product-title,.product-title,a[href*="/products/"]';
  const maps = new Map(scopes.map(scope => [scope, new Map()]));
  const stats = { locale, textChanges: 0, attributeChanges: 0, interfaceChanges: 0, conflicts: [], matched: [], interfaceUnmatched: [] };
  const matched = new Set();
  let stopped = false;
  let scheduled = false;
  let frameId = null;
  let observer = null;

  for (const entry of config.entries || []) {
    if (!entry || typeof entry.source !== 'string' || !entry.source ||
        typeof entry.target !== 'string' || !entry.target || /[<>]/.test(entry.source + entry.target)) continue;
    for (const scope of entry.scopes || []) {
      if (!maps.has(scope)) continue;
      const map = maps.get(scope);
      const prior = map.get(entry.source);
      if (prior && prior.target !== entry.target) {
        map.set(entry.source, null);
        stats.conflicts.push(entry.id);
      } else if (!map.has(entry.source)) map.set(entry.source, entry);
    }
  }
  function excluded(element) {
    return !element || Boolean(element.closest(protectedSelector));
  }
  function record(entry) {
    matched.add(entry.id);
    stats.matched = Array.from(matched);
  }
  function translateRoot(root, map, scope) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      if (excluded(node.parentElement)) continue;
      const original = node.nodeValue;
      const trimmed = original.trim();
      const entry = map.get(original) || map.get(trimmed);
      if (!entry) continue;
      const leading = original.slice(0, original.length - original.trimStart().length);
      const trailing = original.slice(original.trimEnd().length);
      const target = leading + entry.target + trailing;
      if (original !== target) {
        node.nodeValue = target;
        stats.textChanges += 1;
        record(entry);
      }
    }
    if (scope === '#MainContent') return;
    for (const element of [root, ...root.querySelectorAll('[aria-label],[title]')]) {
      if (excluded(element)) continue;
      for (const attribute of ['aria-label', 'title']) {
        const current = element.getAttribute(attribute);
        const entry = map.get(current);
        if (entry && current !== entry.target) {
          element.setAttribute(attribute, entry.target);
          stats.attributeChanges += 1;
          record(entry);
        }
      }
    }
  }
  function translateNewsletter() {
    const unmatched = [];
    for (const entry of config.themeInterface || []) {
      if (!entry || typeof entry.selector !== 'string' || !entry.selector.startsWith('footer-group ') ||
          entry.controlId !== 'NewsletterForm--sections--26210408857884__footer' ||
          typeof entry.source !== 'string' || typeof entry.target !== 'string' ||
          !['placeholder', 'aria-label', 'text'].includes(entry.attribute)) continue;
      const controls = document.querySelectorAll('[id="' + entry.controlId + '"]');
      if (controls.length !== 1) { unmatched.push(entry.id); continue; }
      const control = controls[0];
      if (!control.matches('input[type="email"][name="contact[email]"]') || !control.closest('footer-group')) continue;
      const form = control.closest('form');
      if (!form) continue;
      let elements;
      try { elements = document.querySelectorAll(entry.selector); } catch (_) { continue; }
      if (elements.length !== 1) { unmatched.push(entry.id); continue; }
      const element = elements[0];
      if (!element.closest('footer-group')) continue;
      const isText = entry.attribute === 'text';
      const allowed = entry.attribute === 'placeholder' ? element === control : isText
        ? element.tagName === 'LABEL' && element.getAttribute('for') === entry.controlId &&
          element.childElementCount === 0 && element.closest('form') === form
        : element.matches('button[type="submit"]') && element.closest('form') === form;
      if (!allowed) continue;
      const current = isText ? element.textContent : element.getAttribute(entry.attribute);
      if (current === entry.target) continue;
      if (current !== entry.source) { unmatched.push(entry.id); continue; }
      if (isText) element.textContent = entry.target;
      else element.setAttribute(entry.attribute, entry.target);
      stats.interfaceChanges += 1;
      record(entry);
    }
    stats.interfaceUnmatched = unmatched;
  }
  function translateGermanCartHeading() {
    if (locale !== 'de') return;
    for (const heading of document.querySelectorAll('#MainContent h1')) {
      if (heading.textContent.replace(/\s+/g, ' ').trim() !== 'Dein Warenkorb') continue;
      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      const candidates = [];
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (node.nodeValue.trim() === 'Dein' && !excluded(node.parentElement)) candidates.push(node);
      }
      if (candidates.length !== 1) continue;
      const node = candidates[0];
      const word = node.parentElement.closest('[data-word="Dein"]');
      if (!word || !heading.contains(word)) continue;
      node.nodeValue = node.nodeValue.replace('Dein', 'Ihr');
      word.setAttribute('data-word', 'Ihr');
      stats.textChanges += 1;
      stats.attributeChanges += 1;
      record({ id: 'DE-CART-UI-TITLE' });
    }
  }
  function apply() {
    scheduled = false;
    if (stopped) return;
    for (const scope of scopes) {
      for (const root of document.querySelectorAll(scope)) translateRoot(root, maps.get(scope), scope);
    }
    translateGermanCartHeading();
    translateNewsletter();
  }
  function schedule() {
    if (stopped || scheduled) return;
    scheduled = true;
    frameId = window.requestAnimationFrame(apply);
  }
  function start() {
    if (stopped) return;
    apply();
    observer = new MutationObserver(schedule);
    for (const scope of scopes) {
      for (const root of document.querySelectorAll(scope)) {
        observer.observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'title', 'placeholder'] });
      }
    }
  }
  function destroy() {
    stopped = true;
    if (observer) observer.disconnect();
    if (frameId !== null) window.cancelAnimationFrame(frameId);
    document.removeEventListener('DOMContentLoaded', start);
    window.removeEventListener('load', schedule);
  }
  window[namespace] = { version: '1.0.0-release', stats, refresh: apply, destroy };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('load', schedule, { once: true });
})();


